import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { RootState, useDispatch, useSelector } from "src/store";

import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { deleteUniversalLicense } from "@devices/store";
import { License } from "@devices/types";
import { selectGroupById } from "@groups/store/selectors";
import { PermissionService } from "@services/permissionService/permissionService";
import { DangerOutlinedButton } from "@shared/CustomButton";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const ActionCell = (props: License) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["sidepanels"]);
    const { data: workspace } = useCurrentWorkspace();
    const location = useSelector((state: RootState) => selectGroupById(state, props.groupId), shallowEqual);

    const permission = PermissionService();
    const cannotRemove = permission.groupAbility(location || null, workspace).cannot("manage", "UniversalLicense");

    const onRemove = async () => {
        try {
            await dispatch(deleteUniversalLicense(props.id)).unwrap();
            showSuccessToast(t("sidepanels:groupPanel.toast.licenseRemoved"));
        } catch (err) {
            const error = err as Error;
            showErrorToast(error.message || t("sidepanels:groupPanel.toast.licenseRemovedError"));
        }
    };

    return (
        <MinimalTableCell align="right" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            <DangerOutlinedButton
                onClick={onRemove}
                disabled={cannotRemove}
                tooltipProps={{
                    title: cannotRemove
                        ? t("sidepanels:groupPanel.tooltip.cannotRemoveUniversalLicense")
                        : t("sidepanels:groupPanel.tooltip.deleteUniversalLicense"),
                }}
            >
                <i className="fa-solid fa-trash" />
            </DangerOutlinedButton>
        </MinimalTableCell>
    );
};
